import { ThemeConfig } from "antd";
import { merge } from "lodash-es";

import { themeConfig as sharedThemeConfig } from "../shared";

import { demandCaptureTokens } from "./tokens";

const { color, font, radius } = demandCaptureTokens;

export const demandCaptureTheme: ThemeConfig = {
  token: {
    fontFamily: font.family,
    fontFamilyCode: font.family,
    colorPrimary: color.accent.primary,
    colorText: color.text.body,
    colorTextSecondary: color.text.secondary,
    colorTextTertiary: color.text.label,
    colorTextDisabled: color.text.disabled,
    borderRadius: radius.md,
  },
};

export const themeConfig: ThemeConfig = merge(
  {},
  sharedThemeConfig,
  demandCaptureTheme,
);

export { demandCaptureTokens } from "./tokens";
export type { DemandCaptureTokens } from "./tokens";
